import React from "react";
import { Link } from "react-router-dom";

const TopicOne = () => {
  return (
    <div className="quality-section-market">
      <div className="quality-header-market">
        <h1>Trade the world’s most popular currency pairs with The Pips</h1>
        <p>
          The foreign exchange (forex) market is the largest and most dynamic
          financial market, with over $7 trillion traded daily. At The Pips, you
          can access major, minor, and exotic currency pairs, all with low and
          stable spreads, ultra-fast execution, and no requotes. 
          {/* Whether you’re
          a seasoned trader or just getting started, The Pips provides the
          tools, technology, and transparency you need to make the most of every
          trade. */}
        </p>
      </div>
    </div>
  );
};

export default TopicOne;
